/**
 * Width tiers for dialogs, so a label/value stack and a seven-column table are not forced to the same size.
 *
 * Pick the narrowest tier the content reads well in. Append whatever overflow behaviour the dialog needs.
 *
 * ```tsx
 * <DialogContent className={`${dialogMedium} overflow-hidden`}>
 * ```
 *
 * Why the wider tiers look the way they do: `DialogContent` carries its own max-width utility at the sm
 * breakpoint, and Tailwind emits that rule after every other max-width utility — named or arbitrary. At equal
 * specificity the later rule wins, so a dialog handed a wider max-width silently renders at the default width
 * anyway. That is why several dialogs here were narrower than their classes claimed. Neutralising max-width and
 * driving the size with a width utility is what actually works, and it is kept in one place because
 * hand-writing it is precisely how it came to be wrong in most of them.
 */

/**
 * The shadcn default width. Deliberately sets no width utility — the default already suits a short label/value
 * stack or a single input, and nothing needs overriding.
 */
export const dialogNarrow = "max-h-[90vh]";

/** Room for long file paths, a serialized value, or old/new tabs, without spanning the viewport. */
export const dialogMedium = "w-[92vw] max-w-none sm:w-[46rem] sm:max-w-none max-h-[90vh]";

/** For multi-column tables, SQL, and large configuration diffs that genuinely need the width. */
export const dialogWide = "w-[92vw] max-w-none sm:w-[65vw] sm:max-w-none max-h-[90vh]";
